module.exports = __webpack_public_path__ + "img/upsf.2ff9d0ee.png";